import { LuX, LuSearch, LuCircleCheckBig } from "react-icons/lu";
export default function TableList(
    {
        title,
        icon: Icon,
        items,
        selectedId,
        onToggle,
        onClear,
        searchValue,
        onSearchChange,
        placeholderSearch,
        columns, data
    }) {
    console.log('items que llegan', items)
    return (
        <div className="flex flex-col h-[500px] bg-white border rounded-2xl overflow-hidden shadow-sm">
            <div className="p-4 border-b bg-custom-green-ccard-1/95 flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <h3 className="font-medium text-sm text-white">{title}</h3>
                    {/* podria poner un icono aqui */}
                    <span className="text-xs px-2 py-0.5 rounded-lg bg-blue-500 border">{items.length}</span>
                </div>
                {selectedId && selectedId.size > 0 && (
                    <button
                        onClick={onClear}
                        className="text-xs text-muted-foreground hover:text-foreground flex items-center gap-1"
                    >
                        <LuX className="w-6 h-6 text-white" />
                    </button>
                )}
            </div>
            {/*Buscaodr */}
            <div className="p-3 border-b">
                <div className="relative">
                    <LuSearch className="absolute left-3 top-2.5 h-4 w-4 text-gray-500" />
                    <input
                        placeholder={placeholderSearch}
                        className="w-full pl-9 pr-4 py-2 text-sm outline-none focus:ring-1 focus:ring-custom-green-ccard-2"
                        type="text"
                        value={searchValue}
                        onChange={(e) => onSearchChange(e.target.value)}
                    />
                </div>
            </div>

            {/*lista */}
            <div>
                {items.length === 0 ? (
                    <div>
                        <p>No se encontraron resultados</p>
                    </div>
                ) : (
                    items.map((item) => {
                        const isSelected = selectedId.has(item.id);

                        const rowBase =
                            "flex items-center justify-between p-3 rounded-lg border cursor-pointer transition-all hover:bg-secondary/50";
                        const rowSelected = "bg-primary/5 border-primary/50";
                        const rowUnselected = "bg-card border-transparent hover:border-border";

                        const checkboxBase =
                            "w-4 h-4 rounded border flex items-center justify-center transition-colors border-muted-foreground/30";
                        const checkboxSelected = "bg-primary border-primary";

                        return (
                            <div
                                key={item.id}
                                onClick={() => onToggle(item.id)}
                                className={`${rowBase} ${isSelected ? rowSelected : rowUnselected}`}
                            >
                                <div className="flex items-center gap-3">
                                    <div
                                        className={`${checkboxBase} ${isSelected ? checkboxSelected : ""}`}
                                    >
                                        {isSelected && (
                                            <LuCircleCheckBig className="w-4 h-4 text-custom-green-ccard-1" />
                                        )}
                                    </div>
                                </div>
                                <p>{item.name}</p>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
    );
}